import * as joint from '@joint/core'

/**
 * C4 Hexagon shape - six-sided polygon
 */
export const C4Hexagon = joint.dia.Element.define(
  'c4.Hexagon',
  {
    size: { width: 240, height: 180 },
    attrs: {
      body: {
        refPoints: '50,0 100,25 100,75 50,100 0,75 0,25',
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
        refWidth: '100%',
        refHeight: '100%',
      },
      nameLabel: {
        refX: '50%',
        refY: '35%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: '50%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Hexagon]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: '65%',
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '70%',
          height: 40,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      { tagName: 'polygon', selector: 'body' },
      { tagName: 'text', selector: 'nameLabel' },
      { tagName: 'text', selector: 'typeLabel' },
      { tagName: 'text', selector: 'descriptionLabel' },
    ],
  }
)

export function createHexagon(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[${technology}]` : '[Hexagon]'

  const hexagon = new C4Hexagon({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return hexagon
}
